import { Spinner } from 'components/ui';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import AccountService from 'views/v2/services/accountService';
import { ImSpinner } from "react-icons/im";

function GoogleCallbackPage() {
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const extractedParams = {};
  for (let [key, value] of params.entries()) {
    extractedParams[key] = value;
  }

  // Inform parent window
  if (window.opener) {
    window.opener.postMessage(
      { type: "GMAIL", payload: extractedParams },
      "*"
    );
  }
  window.close();

  return (
    <div className="mb-2 w-full h-screen flex items-center justify-center">
      <Spinner size={40} indicator={ImSpinner} />
    </div>
  );
}

export default GoogleCallbackPage;
